import React, { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputOtp } from "primereact/inputotp";
import { Toast } from "primereact/toast";
import { QRCodeCanvas } from "qrcode.react";
import './estilo.css';

export const Codigo2FA = ({ visible, onHide, funcion, modo = "VERIFICACION", qrCodeUrl = null }) => {
    const [codigo2fa, setCodigo2fa] = useState("");
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const showToast = (severity, summary, detail) => {
        toast.current.show({ severity, summary, detail, life: 3000 });
    };

    const handleConfirm = () => {
        if (loading) return;
        if (!codigo2fa || codigo2fa.length !== 6) {
            showToast("warn", "Advertencia", "El código debe contener 6 dígitos.");
            return;
        }
        setLoading(true);
        funcion(codigo2fa).then(() => {
            setCodigo2fa("");
        }).catch((error) => {
            // El error ya se maneja visualmente en Login, se puede atrapar aquí el error
        }).finally(() => {
            setLoading(false);
        });
    };

    // Disparar cuando se completen los 6 dígitos
    useEffect(() => {
        if (codigo2fa && codigo2fa.length === 6) {
            handleConfirm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codigo2fa]);

    const customInput = ({ events, props }) => {
        return (
            <React.Fragment key={props.key}> {/* Usamos key seguro si viene en props */}
                <input {...events} {...props} type="text" autoComplete="one-time-code"
                    className="otp-input-personalizado"
                    onKeyDown={(e) => {
                        if (events.onKeyDown) {
                            events.onKeyDown(e);
                        }
                    }}
                />
                {props['data-index'] === 2 && (
                    <div className="px-3" style={{ display: "flex", alignItems: "center" }}>
                        <i className="pi pi-minus" />
                    </div>
                )}
            </React.Fragment>
        );
    };

    const headerContent = (
        <div style={{ textAlign: "center", fontSize: "1.2rem", fontWeight: "bold" }}>
            {modo === "VERIFICACION" ? "Autenticación de Dos Factores (2FA)" : "Vinculación de Dispositivo"}
        </div>
    );

    const footer = (
        <div className="p-d-flex p-jc-center" style={{ gap: "1rem" }}>
            <Button label={modo === "VERIFICACION" ? "Verificar" : "Confirmar vinculación"} style={{ fontSize: "1rem" }} icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"} onClick={handleConfirm} disabled={loading} />
            <Button label="Cancelar" style={{ fontSize: "1rem" }} icon="pi pi-times" className="p-button-secondary" onClick={() => { setCodigo2fa(""); onHide(); }} />
        </div>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog header={headerContent} className="dialog-personalizado" visible={visible} style={{ width: "30vw" }} footer={footer} onHide={onHide}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                    {modo === "ENLACE" ? (
                        <>
                            <div style={{ marginBottom: "1rem", fontSize: "1rem" }}>
                                Escanea el código QR con Microsoft o Google Authenticator y luego ingresa el código de 6 dígitos.
                            </div>
                            <div style={{ marginBottom: "1rem" }}>
                                {qrCodeUrl ? (
                                    <QRCodeCanvas value={qrCodeUrl} size={200} />
                                ) : (
                                    <div>Cargando código QR...</div>
                                )}
                            </div>
                        </>
                    ) : (
                        <div style={{ marginBottom: "1rem", fontSize: "1rem" }}>
                            Ingrese el código de verificación de 6 dígitos generado en su aplicación de autenticación (por ejemplo, Microsoft o Google Authenticator).
                        </div>
                    )}

                    <div className="flex justify-content-center">
                        <InputOtp value={codigo2fa} onChange={(e) => setCodigo2fa(e.value)} length={6} inputTemplate={customInput} style={{ gap: 0 }} integerOnly />
                    </div>
                </div>
            </Dialog>
        </>
    );
};